import { GetCouponModel } from "@factory/model/query-model-coupon";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { couponFormDefault } from "./form.default";
import { CouponFormSchema } from "./form.rule";

export const useFormDefaultCoupon = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetCouponModel | undefined) => {
    return !cachedValue
      ? couponFormDefault
     : ({
        tenant: cachedValue.tenant,
        name: cachedValue.name,
        description: cachedValue.description,
        couponCode: cachedValue.coupon_code,
        validUntil: cachedValue.valid_until,
        level: cachedValue.level,
        purpose: cachedValue.purpose,
        valueType: cachedValue.value_type,
        points: cachedValue.points,
        stamps: cachedValue.stamps,
        redeemLimit: cachedValue.redeem_limit,
        isUserRedeemable: Boolean(cachedValue.is_user_redeemable),
      } as CouponFormSchema);
  };

  return {
    getDefault,
  };
};
